var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3124_19611)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.95825 7.99992C1.95825 4.6632 4.6632 1.95825 7.99992 1.95825C11.3366 1.95825 14.0416 4.6632 14.0416 7.99992C14.0416 11.3366 11.3366 14.0416 7.99992 14.0416C4.6632 14.0416 1.95825 11.3366 1.95825 7.99992ZM7.99992 0.708252C3.97284 0.708252 0.708252 3.97284 0.708252 7.99992C0.708252 12.027 3.97284 15.2916 7.99992 15.2916C12.027 15.2916 15.2916 12.027 15.2916 7.99992C15.2916 3.97284 12.027 0.708252 7.99992 0.708252ZM6.44185 5.55797C6.19777 5.31389 5.80204 5.31389 5.55797 5.55797C5.31389 5.80204 5.31389 6.19777 5.55797 6.44185L7.11602 7.99991L5.55797 9.55797C5.31389 9.80204 5.31389 10.1978 5.55797 10.4418C5.80204 10.6859 6.19777 10.6859 6.44185 10.4418L7.99991 8.88379L9.55797 10.4418C9.80204 10.6859 10.1978 10.6859 10.4418 10.4418C10.6859 10.1978 10.6859 9.80204 10.4418 9.55797L8.88379 7.99991L10.4418 6.44185C10.6859 6.19777 10.6859 5.80204 10.4418 5.55797C10.1978 5.31389 9.80204 5.31389 9.55797 5.55797L7.99991 7.11602L6.44185 5.55797Z",
  fill: "#B3261E",
  stroke: "white",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3124_19611"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgCategoryCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryCancel);
export default __webpack_public_path__ + "static/media/category-cancel.ea4e85d3.svg";
export { ForwardRef as ReactComponent };